module.exports = __webpack_public_path__ + "img/help2.257fafe1.jpg";